import React from 'react';

function TestimonialSection1() {
  return (
    <div className="container-fluid my-5">
      {/* Heading */}
      <h2 className="text-center fw-bold text-dark mb-5">TESTIMONIAL</h2>

      {/* Testimonials */}
      <div className="testimonial-container d-flex flex-wrap justify-content-center gap-5">
        {/* Box 1 */}
        <div className="testimonial-box bg-col text-center p-4 rounded">
          <img
            src="/Images/Lisa_Davis.png"
            alt="User"
            className="rounded-circle mb-3"
          />
          <div className="text-warning mb-2">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-half"></i>
          </div>
          <p className="text-light">
            <i className="text-light fs-4 bi bi-quote text-muted"></i>
            Pharmacy Store is my go-to for over-the-counter medications and
            health products. They have a wide selection, and their website makes
            it easy to order online. The only improvement I'd suggest is
            expanding their beauty and skincare section.
            <i className="text-dark fs-4 bi bi-quote rotate-quote"></i>
          </p>
          <h5 className="fw-bold text-dark mb-0">Lisa Davis</h5>
        </div>

        {/* Box 2 */}
        <div className="testimonial-box bg-col text-center p-4 rounded">
          <img
            src="/Images/Michael_Chang.png"
            alt="User"
            className="rounded-circle mb-3"
          />
          <div className="text-warning mb-2">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star"></i>
          </div>
          <p className="text-light">
            <i className="text-dark fs-4 bi bi-quote text-muted"></i>
            Pharmacy Store is my go-to for over-the-counter medications and
            health products. They have a wide selection, and their website makes
            it easy to order online. The only improvement I'd suggest is
            expanding their beauty and skincare section.
            <i className="text-dark fs-4 bi bi-quote rotate-quote"></i>
          </p>
          <h5 className="fw-bold text-light mb-0">Michael Chang</h5>
        </div>

        {/* Box 3 */}
        <div className="testimonial-box bg-col text-center p-4 rounded">
          <img
            src="/Images/Emily_Roberts.png"
            alt="User"
            className="rounded-circle mb-3"
          />
          <div className="text-warning mb-2">
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
            <i className="bi bi-star-fill"></i>
          </div>
          <p className="text-light">
            <i className="text-light fs-4 bi bi-quote "></i>
            Pharmacy Store is my go-to for over-the-counter medications and
            health products. They have a wide selection, and their website makes
            it easy to order online. The only improvement I'd suggest is
            expanding their beauty and skincare section.
            <i className="text-light fs-4 bi bi-quote rotate-quote"></i>
          </p>
          <h5 className="fw-bold text-light mb-0">Emily Roberts</h5>
        </div>
      </div>

      {/* Responsive and Hover CSS */}
      <style>{`
        .testimonial-box {
          width: 350px;
          transition: all 0.3s ease;
        }
        .testimonial-box img {
          width: 90px;
          height: 90px;
          object-fit: cover;
        }
        .testimonial-box:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        /* Large screens (>=1200px) */
        @media (min-width: 1200px) {
          .testimonial-container {
            gap: 3rem;
          }
          .testimonial-box {
            width: 360px;
          }
        }

        /* Tablets (768px to 1199px) */
        @media (max-width: 1199px) and (min-width: 768px) {
          .testimonial-box {
            width: 320px;
          }
          .testimonial-container {
            gap: 2rem;
          }
        }

        /* Mobile view (<768px) */
        @media (max-width: 767px) {
          .testimonial-container {
            flex-direction: column;
            align-items: center;
          }
          .testimonial-box {
            width: 90%;
          }
        }
      `}</style>
    </div>
  );
}

export default TestimonialSection1;